import { HttpQueueRecordFindAll } from '../../../../domain/http';
import { HttpClientAdapter } from '../../../../infra/adapters';
import { FindAllQueueRecordsData } from '../../../../application/data';

export const MakeFindAllQueueRecords = () => {
  const httpClientAdapter = new HttpClientAdapter();
  const httpClient = new HttpQueueRecordFindAll(httpClientAdapter);
  return new FindAllQueueRecordsData(httpClient);
};
